import src from "IMAGE";
export default { src, width: 745, height: 135, blurWidth: 8, blurHeight: 1, blurDataURL: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAABCAYAAADjAO9DAAAALElEQVR42gEhAN7/ALrBweZ2dXaMpaCjxY6HgKSQhn6loaSixHZyco2/srXkRvATy5G4CD0AAAAASUVORK5CYII="};
